class ScrollTop extends HTMLElement {
  constructor() {
    super();
    this.buttonContainer = this.querySelector('.scroll-to-top');
    this.button = this.querySelector('button');
    
    this.onScroll = this.onScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.calculateThreshold = this.calculateThreshold.bind(this);
    this.scrollThreshold = window.innerHeight;
  }

  connectedCallback() {
    // Calculate once on load instead of every scroll
    this.calculateThreshold();
    
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.calculateThreshold, { passive: true });
    this.button.addEventListener('click', this.scrollToTop);
    
    // Run initially to check current scroll position on load
    this.onScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.calculateThreshold);
    this.button.removeEventListener('click', this.scrollToTop);
  }

  calculateThreshold() {
    const firstSection = document.querySelector('.shopify-section');
    this.scrollThreshold = firstSection ? firstSection.offsetHeight : window.innerHeight;
  }

  onScroll() {
    if (window.scrollY > this.scrollThreshold) {
      if (!this.buttonContainer.classList.contains('show')) {
        this.buttonContainer.classList.add('show');
      }
    } else {
      if (this.buttonContainer.classList.contains('show')) {
        this.buttonContainer.classList.remove('show');
      }
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}

customElements.define('scroll-top', ScrollTop);
